(function (angular) {
    'use strict';

    angular.module('webChatReports')
        .factory('webChatService', [
            '$http', "portalConfig", "$q", function ($http, portalConfig, $q) {
                var urlBase = portalConfig.urlBase;


                var fac = {
                    getQueriedData: getQueriedData,
                    getLiveData: getLiveData
                };
                return fac;


                function getQueriedData(id, data, teamId, timezone) {
                    var url = urlBase + "/apispaces/" + id + "/analytics/chats?from=" + data.from.value.toISOString() + "&to=" + data.to.value.toISOString() + "&by=" + data.by;
                    if (teamId) {
                        url = url + "&teamId=" + teamId;
                    }
                    if (timezone) {
                        url = url + '&timezone=' + timezone;
                    }
                    return $http.get(url)
                        .then(getQueriedDataComplete)
                        .catch(getQueriedDataFailed);

                    function getQueriedDataComplete(response) {
                        return response.data;
                    }

                    function getQueriedDataFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }

                }

                function getLiveData(id, teamId) {
                    var url = urlBase + "/apispaces/" + id + "/analytics/chats/live";
                    if (teamId) {
                        url = url + "?teamId=" + teamId;
                    }
                    return $http.get(url)
                        .then(getLiveDataComplete)
                        .catch(getLiveDataFailed);

                    function getLiveDataComplete(response) {
                        return response.data;
                    }

                    function getLiveDataFailed(error) {
                        console.error(JSON.stringify(error));
                        return $q.reject(error);
                    }

                }

            }
        ]);
})(window.angular);